import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AlertController } from '@ionic/angular';
import { Strings } from 'src/app/enum/strings.enum';
import { AuthService } from '../../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements  CanLoad {

  constructor (private alertCtrl: AlertController,private authService: AuthService, private router: Router){}
 
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      console.log('Auth')
      return this.authService.checkAuth().then(async user => {
        // console.log('auth guard checking user: ', user);
        const profile: any = await this.authService.getUserData(user.uid);
        // console.log('auth guard checking profile: ', profile);
        if(profile) return true;
        else {
          // redrect to login page
          this.router.navigateByUrl('/login');
          return false;
        }
      })
      .catch(e => {
        console.log(e);
        this.navigate('/login');
          return false;
      });
  }


  navigate(url:string) {
    this.router.navigateByUrl(url, {replaceUrl: true});
    return false;
  }

  async checkForAlert(roleType:string) {
    const id = await this.authService.getId();
    if(id) {
      console.log('alert: ', id);
      this.showAlert(roleType);
    } else {
      this.authService.logout();
      this.navigate(Strings.LOGIN);
    }
  }

  showAlert(role:string) {
    this.alertCtrl.create({
      header: 'Authentication Failed',
      message: 'Please check your Internet Connectivity and tr again',
      buttons: [
        {
          text: 'Logout',
          handler: () => {
            this.authService.logout();
            this.navigate(Strings.LOGIN);
          }
        },
        {
          text: 'Retry',
          handler: () => {
            let url = Strings.TABS;
            if(role == 'admin') url = Strings.ADMIN;
            this.navigate(url);
          }
        }
      ]
    })
    .then(alertEl => alertEl.present());
  }
}
